import { DigitalData } from "@/src/types/digitalData";

import { PRODUCT_ABBREVIATION } from "./constants";
import { isValidDigitalData } from "./validation";

const RETRY_DELAY_MS = 200;
const MAX_RETRIES = 50;

let isRetryScheduled = false;
let retryTimerId: ReturnType<typeof setTimeout> | undefined = undefined;

const canSendDatalayer = (): boolean =>
  Boolean(
    globalThis.ALMA?.sammioDatalayerSenderReady === true &&
    typeof globalThis.digitalData === "object"
  );

export const dispatchDataLayerEvent = (
  dataLayer: DigitalData,
  retryCount = 0
): void => {
  if (!canSendDatalayer()) {
    if (
      retryCount < MAX_RETRIES &&
      typeof globalThis.digitalData === "object" &&
      !isRetryScheduled
    ) {
      isRetryScheduled = true;
      retryTimerId = setTimeout(() => {
        retryTimerId = undefined;
        isRetryScheduled = false;
        dispatchDataLayerEvent(
          globalThis.digitalData as DigitalData,
          retryCount + 1
        );
      }, RETRY_DELAY_MS);
    }
    return;
  }

  if (retryTimerId !== undefined) {
    clearTimeout(retryTimerId);
    retryTimerId = undefined;
  }
  isRetryScheduled = false;

  if (!isValidDigitalData(dataLayer)) {
    console.error("[DDL] Invalid digitalData structure, not dispatching event");
    return;
  }

  document.dispatchEvent(
    new globalThis.CustomEvent("sammio-datalayer-send", {
      detail: {
        site: PRODUCT_ABBREVIATION,
        subsite: "www",
        dataLayer
      }
    })
  );
};

/** Alias for dispatchDataLayerEvent (matches Sammio documentation) */
export const sendDataLayer = dispatchDataLayerEvent;
